<template>
	<v-app dark id="jman">
		<v-navigation-drawer
			:clipped="$vuetify.breakpoint.lgAndUp"
			v-model="drawer"
			fixed
			app
		>
			<v-list dense>
				<template v-for="item in items">
					<v-layout
						v-if="item.heading"
						:key="item.heading"
						row
						align-center
					>
						<v-flex xs6>
							<v-subheader v-if="item.heading">
								{{ item.heading }}
							</v-subheader>
						</v-flex>
						<v-flex xs6 class="text-xs-center">
							<a href="#!" class="body-2 black--text">EDIT</a>
						</v-flex>
					</v-layout>
					<v-list-group
						v-else-if="item.children"
						v-model="item.model"
						:key="item.text"
						:prepend-icon="item.model ? item.icon : item['icon-alt']"
						append-icon=""
					>
						<v-list-tile slot="activator">
							<v-list-tile-content>
								<v-list-tile-title>
									{{ item.text }}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile
							v-for="(child, i) in item.children"
							:key="i"
							@click=""
						>
							<v-list-tile-action v-if="child.icon">
								<v-icon>{{ child.icon }}</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>
									{{ child.text }}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
					<v-list-tile v-else :key="item.text" :to="item.path">
						<v-list-tile-action>
							<v-icon>{{ item.icon }}</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>
								{{ item.text }}
							</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</template>
			</v-list>
		</v-navigation-drawer>
		<v-toolbar
			:clipped-left="$vuetify.breakpoint.lgAndUp"
			color="blue darken-3"
			dark
			app
			fixed
		>
			<v-toolbar-title style="width: 300px" class="ml-0 pl-3">
				<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
				<span class="hidden-sm-and-down">JMan</span>
			</v-toolbar-title>
			<v-text-field
				flat
				solo-inverted
				hide-details
				prepend-inner-icon="fa-search"
				label="Search"
				class="hidden-sm-and-down"
			></v-text-field>
			<v-spacer></v-spacer>
			<v-btn icon>
				<v-icon>fa-bell</v-icon>
			</v-btn>
			<v-chip small color="info" text-color="white">
				<v-icon left small>fa-cloud-upload-alt</v-icon>
				1
			</v-chip>
			<v-btn icon>
				<v-badge right small overlap color="secondary" :value="0">
					<small slot="badge">?</small>
					<v-icon v-if="online" color="success lighten-3">fa-wifi</v-icon>
					<v-icon v-else color="secondary lighten-3">fa-database</v-icon>
				</v-badge>
			</v-btn>
			<v-btn icon large>
				<v-avatar size="32px" color="blue lighten-5" >
					<img
						src="./assets/images/jman-logo.svg"
						alt="JMan"
					>
				</v-avatar>
			</v-btn>
		</v-toolbar>
		<v-content>
			<v-container fluid fill-height>
				<v-layout v-if="loggedIn" child-flex>

					<jm-entities></jm-entities>

				</v-layout>
			</v-container>
		</v-content>
		<v-btn
			fab
			bottom
			right
			color="pink"
			dark
			fixed
			@click.stop="dialogue = !dialogue"
		>
			<v-icon>fa-plus</v-icon>
		</v-btn>

		<jm-login></jm-login>

		<jm-confirm-yes-no></jm-confirm-yes-no>

		<jm-row-actions></jm-row-actions>

		<v-dialog v-model="dialogue" width="800px">
			<jm-edit :shown="dialogue" @visibilityChange="showEditDialog"></jm-edit>
		</v-dialog>


	</v-app>
</template>

<script>
import Vuex from 'vuex'
import store from '@/store'
import JmLogin from './components/Login'
import JmConfirmYesNo from './components/ConfirmYesNo'
import JmRowActions from './components/widgets/RowActions'
import JmEdit from './components/Edit'
import JmEntities from './components/Entities'

export default {
	name: "JManApp",

	store,

	props: {
		source: String
	},

	data: () => ({
		dialogue: false,
		drawer: null,
		items: [
			{ icon: 'fa-globe-africa', text: 'Journeys', path: '/journey' },
			{ icon: 'fa-map-pin', text: 'Locations', path:'/location' },
			{ icon: 'fa-car', text: 'Vehicles', path: '/asset' },
			{ icon: 'fa-users', text: 'People', path: '/person' },
			{ icon: 'fa-cog', text: 'Settings' },
			{ icon: 'fa-comment', text: 'Send feedback' },
			{ icon: 'fa-question-circle', text: 'Help' }
		],

		loginDialogue: {
			credentials: {
				handle: null,
				password: null
			},
			showPwd: false
		}
	}),

	computed: {
		...Vuex.mapState({ auth: "user", online: (state) => state.dbsync.online }),

		loggedIn () {
			return this.$store.state.user.status.loggedIn;
		},

		loggedOut () {
			return !this.loggedIn;
		}
	},

	methods: {
		showEditDialog (isVisible) {
			this.dialogue = !!isVisible;
		}
	},

	async mounted () {
		await this.$store.dispatch('restoreSession');
		await this.$store.dispatch('dbsync/readFromNetwork');
	},

	components: {
		JmLogin,
		JmConfirmYesNo,
		JmRowActions,
		JmEdit,
		JmEntities
	}
}
</script>



// WEBPACK FOOTER //
// src/JManApp.vue